import { render } from "./WicePast.vue?vue&type=template&id=7108d8a8&scoped=true"
import script from "./WicePast.vue?vue&type=script&lang=js"
export * from "./WicePast.vue?vue&type=script&lang=js"

import "./WicePast.vue?vue&type=style&index=0&id=7108d8a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7108d8a8"]])

export default __exports__